/** @jsxImportSource @emotion/react */

import React from 'react';
import Contact from '@component/iyagigo/hub/contact';
import PageTemplate from '@page/iyagigo/page-template';
import { IYAGIGO_PATH } from '@constant/iyagigo/route-path';
import { useNavigate } from 'react-router-dom';

const ContactPage: React.FC<any> = () => {
  const navigate = useNavigate();

  return (
    <PageTemplate
      title='문의 및 의견'
      mode={'back'}
      handleNavigationClick={() => navigate(IYAGIGO_PATH.HUB_HOME_PATH)}>
      <Contact />
    </PageTemplate>
  );
};

export default ContactPage;
